import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faCheckCircle,
  faExclamationCircle,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import {
  ToastContainer,
  toast,
  ToastType as ToastifyType,
  Slide,
  ToastPosition,
  TypeOptions as ToastifyOptions,
} from "react-toastify";
import deepFreeze, { DeepReadonly } from "deep-freeze";

export const ToastType = ToastifyType;
export type TypeOptions = Extract<ToastifyOptions, "error" | "success" | "warning">;
type IconMap = Readonly<{ [type in TypeOptions]: IconDefinition }>;
const iconMap: DeepReadonly<IconMap> = deepFreeze({
  [ToastType.ERROR]: faExclamationTriangle,
  [ToastType.SUCCESS]: faCheckCircle,
  [ToastType.WARNING]: faExclamationCircle,
});

export function showToast(message: string, type?: TypeOptions): void {
  const toastType = type ?? ToastType.SUCCESS;
  const icon: DeepReadonly<IconDefinition> = iconMap[toastType];
  toast(
    <>
      <FontAwesomeIcon icon={icon} /> {message}
    </>,
    {
      type: toastType,
      hideProgressBar: true,
      transition: Slide,
      position: ToastPosition.BOTTOM_RIGHT,
    }
  );
}

export default styled(ToastContainer)`
  .Toastify__toast {
    min-height: 3rem;
    border-radius: 0.1875rem;
    background-color: #fff;
    color: #404040;
    font-size: 0.875rem;
    border-left: solid 0.3125rem;
  }
  .Toastify__toast-body {
    white-space: pre-wrap;
    word-break: break-word;
  }
  .Toastify__close-button {
    color: #404040;
  }
  .Toastify__toast--success {
    border-left-color: #37b24d;
    svg {
      color: #37b24d;
    }
  }
  .Toastify__toast--error {
    border-left-color: #f03e3e;
    svg {
      color: #f03e3e;
    }
  }
  .Toastify__toast--warning {
    border-left-color: #f7941d;
    svg {
      color: #f7941d;
    }
  }
`;
